const AWS = require('aws-sdk')

const SES_CONFIG = {
  accessKeyId: '...',
  secretAccessKey: '...',
  region: 'us-east-1',
}

const AWS_SES = new AWS.SES(SES_CONFIG)

const sendEmail = (recipientEmail) => {
  const params = {
    Source: 'notificacion@taxicontigo.com',
    Destination: {
      ToAddresses: [
        recipientEmail,
      ],
    },
    ReplyToAddresses: [],
    Message: {
      Body: {
        Html: {
          Charset: 'UTF-8',
          Data: `
          <body style="
        font-family:sans-serif;
      ">
    <div style="
          margin: 0 auto;
          width: 600px;
          background-color: #fff;
          font-size: 1.2rem;
          font-style: normal;
          font-weight: normal;
          line-height: 19px;
        " >
      <div style="padding: 20"
      align="center"
      >
        <img style="
              border: 0;
              height: auto;
              width: 100%;
              margin-top: 20px;
              margin-bottom: 20px;
            " alt="Animage"
          src="https://firebasestorage.googleapis.com/v0/b/automatic-tea-290516.appspot.com/o/cuadros_cuadros%201.png?alt=media&token=38c9b35a-aaf7-4b0a-bdc9-4e0d86f6b0a7" />
        <img style="
              border: 0;
              display: block;
              height: auto;
              width: 15%;
            " alt="Animage"
          src="https://firebasestorage.googleapis.com/v0/b/automatic-tea-290516.appspot.com/o/logo.png?alt=media&token=b4fcca0d-57db-44a5-a1cd-efc495dc2f0f" />
      </div>
          <div style="margin: 0 auto; padding: 10px;">
          <div style="
            margin-top: 20px;
            margin-bottom: 0;
            width: 70%;
          ">
            <i style="
             font-size: 1.0rem;
            color: #000;
           font-weight: 600;
            font-family:'Open Sans',arial,sans-serif!important;
          ">
             Bienvenido a Taxi Contigo.
            </i>
          </div>
          <div style="
          margin-top: 20px;
          margin-bottom: 0;
          width: 100%;
  
        ">
        </div>
        </div>
      <table width="100%" align="center"
        style="Margin:0px; Padding:0px; border-collapse:collapse; background-color:rgb(255,255,255);" border="0" ;
        cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td style="width: 50%; padding-right: 5px; background-color: #042E41;">
              <p style=" font-size: 1.1rem; color: #fff; text-align: end;">¿Necesitas</p>
            </td>
            <td style="width: 50%; padding-left: 5px; background-color: #E63B4D;">
              <p style=" font-size: 1.1rem; color: #fff; text-align: start;"> ayuda?</p>
            </td>
          </tr>
          <tr>
            <td style="padding: 10px; text-align:center; background-color:#042E41;">
              <i><img
                  src="https://firebasestorage.googleapis.com/v0/b/automatic-tea-290516.appspot.com/o/public.png?alt=media&token=514f7dba-ea4e-440a-befb-624bcccf637c"
                  alt="public"></i>
              <a
                Style="text-decoration:none; font-size: 0.8rem; vertical-align: top;  color: #fff; font-family:'Open Sans',arial,sans-serif!important;">www.taxicontigo.com</a>
            </td>
  
            <td style="padding: 10px;  text-align:center; background-color: #E63B4D;">
              <i><img
                  src="https://firebasestorage.googleapis.com/v0/b/automatic-tea-290516.appspot.com/o/call.png?alt=media&token=84e90eb1-80ee-418f-a26c-7a9494823a9e"
                  alt="phone"></i>
              <i 
                Style="vertical-align: top; font-size: 0.8rem; color: #fff; font-family:'Open Sans',arial,sans-serif!important;">800-999-10-70</i>
            </td>
  
          </tr>
        </tbody>
      </table>
    </div>
  
  </body>
          `,
        },
      },
      Subject: {
        Charset: 'UTF-8',
        Data: 'Bienvenido a taxi contigo',
      },
    },
  }
  return AWS_SES.sendEmail(params).promise()
}

module.exports = {
  sendEmail,
}
